/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Integrations_Tool_Count_OtherInputs */



/**
* | output |
* | --- |
* | "{count} tools" |
*
* @param {Integrations_Tool_Count_OtherInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_tool_count_other = /** @type {((inputs: Integrations_Tool_Count_OtherInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Tool_Count_OtherInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Werkzeuge`)
	return /** @type {LocalizedString} */ (`${i?.count} tools`)
});